import React from 'react';
import StepLoading from 'components/StepLoading';

const StepLoadingPage = () => {
  return <StepLoading />;
};

export default StepLoadingPage;
